import { render, staticRenderFns } from "./Fechamento.vue?vue&type=template&id=0a7ae9f8&scoped=true&"
import script from "./Fechamento.vue?vue&type=script&lang=js&"
export * from "./Fechamento.vue?vue&type=script&lang=js&"
import style0 from "./Fechamento.vue?vue&type=style&index=0&id=0a7ae9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7ae9f8",
  null
  
)

export default component.exports